import React from 'react';

import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { PRIVATE_SERVICE_PATH } from '../../../../config/paths';

import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';

import { postPrivateService } from '../../../../actions';

import Content from '../../../layout/Content';

import PrivateServiceForm from './PrivateServiceForm';

import { getSubstring } from '../../../../utils/string';

import {
  CONTRACT_DOCUMENT_TYPE,
  CONTRACT_STATUS,
} from '../../../../config/constants';

import { currencyToNumber } from '../../../../utils/number';

import { tzNormalizeDate } from '../../../../utils/date';

import { TIMESTAMP_FORMAT } from '../../../../config/locale';

const NewPrivateService = ({
  breadcrumbs,
  authenticatedUser,
  dispatchPostPrivateService,
}) => {
  const onSubmit = (formValues) => {
    const newFormValues = { ...formValues };

    if (formValues.businessId) {
      newFormValues.businessId =
        typeof formValues.businessId === 'object'
          ? formValues.businessId.value
          : formValues.businessId;
    }

    if (formValues.customerId) {
      newFormValues.customerId =
        typeof formValues.customerId === 'object'
          ? formValues.customerId.value
          : formValues.customerId;
    }

    if (formValues.paymentMethodId) {
      newFormValues.paymentMethodId =
        typeof formValues.paymentMethodId === 'object'
          ? formValues.paymentMethodId.value
          : formValues.paymentMethodId;
    }

    newFormValues.contractStatus =
      typeof formValues.contractStatus === 'object'
        ? formValues.contractStatus.value
        : formValues.contractStatus;

    newFormValues.contractPaymentType =
      typeof formValues.contractPaymentType === 'object'
        ? formValues.contractPaymentType.value
        : formValues.contractPaymentType;

    if (formValues.freeOfChargeCategoryId) {
      newFormValues.freeOfChargeCategoryId =
        typeof formValues.freeOfChargeCategoryId === 'object'
          ? formValues.freeOfChargeCategoryId.value
          : formValues.freeOfChargeCategoryId;
    } else {
      newFormValues.freeOfChargeCategoryId = null;
    }

    if (formValues.freeOfChargeSubCategoryId) {
      newFormValues.freeOfChargeSubCategoryId =
        typeof formValues.freeOfChargeSubCategoryId === 'object'
          ? formValues.freeOfChargeSubCategoryId.value
          : formValues.freeOfChargeSubCategoryId;
    } else {
      newFormValues.freeOfChargeSubCategoryId = null;
    }

    if (formValues.freeOfChargeUserId) {
      newFormValues.freeOfChargeUserId =
        typeof formValues.freeOfChargeUserId === 'object'
          ? formValues.freeOfChargeUserId.value
          : formValues.freeOfChargeUserId;
    } else {
      newFormValues.freeOfChargeUserId = null;
    }

    newFormValues.billingDescription = formValues.billingDescription || null;

    const sortedContractItineraryList = [
      ...(formValues.contractItineraryList || []),
    ].sort((a, b) => {
      if (a.departureTime > b.departureTime) return 1;

      if (a.departureTime < b.departureTime) return -1;

      return 0;
    });

    newFormValues.contractItineraryList = sortedContractItineraryList.map(
      ({
        movementType,
        registeredBusId,
        routeId,
        serviceTypeId,
        authorizedStop,
        routeDetail,
        itineraryId,
        kilometers,
        sourceAddress,
        departureTime,
        destinationAddress,
        arrivalTime,
        firstDriverId,
        secondDriverId,
        thirdDriverId,
        cabinCrewQuantity,
        expectedFuelConsumption,
      }) => ({
        movementType:
          movementType && typeof movementType === 'object'
            ? movementType.value
            : movementType,

        registeredBusId:
          registeredBusId && typeof registeredBusId === 'object'
            ? registeredBusId.value
            : registeredBusId,

        routeId:
          routeId && typeof routeId === 'object' ? routeId.value : routeId,

        serviceTypeId:
          serviceTypeId && typeof serviceTypeId === 'object'
            ? serviceTypeId.value
            : serviceTypeId,

        authorizedStop,

        routeDetail,

        itineraryId: itineraryId && getSubstring(itineraryId),

        kilometers,

        sourceAddress,

        departureTime:
          departureTime &&
          tzNormalizeDate({
            date: departureTime,
            format: TIMESTAMP_FORMAT,
          }),

        destinationAddress,

        arrivalTime:
          arrivalTime &&
          tzNormalizeDate({
            date: arrivalTime,
            format: TIMESTAMP_FORMAT,
          }),

        firstDriverId:
          firstDriverId && typeof firstDriverId === 'object'
            ? firstDriverId.value
            : firstDriverId,

        secondDriverId:
          secondDriverId && typeof secondDriverId === 'object'
            ? secondDriverId.value
            : secondDriverId,

        thirdDriverId:
          thirdDriverId && typeof thirdDriverId === 'object'
            ? thirdDriverId.value
            : thirdDriverId,

        cabinCrewQuantity,

        expectedFuelConsumption,
      }),
    );

    newFormValues.totalAmount = currencyToNumber(formValues.totalAmount);

    newFormValues.amountBeforeDiscount = currencyToNumber(
      formValues.amountBeforeDiscount,
    );

    dispatchPostPrivateService(newFormValues);
  };

  const generateInititalValues = ({
    customer: { firstName, lastName, mobilePhone, email },
  }) => ({
    contractStatus: CONTRACT_STATUS.ACEPTED,

    executiveName: `${firstName} ${lastName}`,

    executivePosition: 'Ejecutivo Cuentas Clave',

    executivePhone: mobilePhone,

    executiveEmail: email,

    contractPaymentType: CONTRACT_DOCUMENT_TYPE.FACTURA,
  });

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Nuevo Servicio Privado"
      subtitle="Crear un nuevo servicio privado"
      content={
        <PrivateServiceForm
          onSubmit={onSubmit}
          initialValues={generateInititalValues(authenticatedUser)}
        />
      }
    />
  );
};

const mapStateToProps = ({ ContractUnit, authentication }) => ({
  breadcrumbs: [
    ...ContractUnit.UnitHome.get('breadcrumbs'),

    {
      text: 'Servicios Privados',
      href: PRIVATE_SERVICE_PATH,
    },

    {
      text: 'Nuevo',
      href: '',
    },
  ],

  authenticatedUser: authentication.get('user'),
});

const mapDispatchToProps = {
  dispatchPostPrivateService: postPrivateService,
};

NewPrivateService.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,

  dispatchPostPrivateService: PropTypes.func.isRequired,

  authenticatedUser: PropTypes.shape({
    customer: PropTypes.shape({
      firstName: PropTypes.string.isRequired,

      lastName: PropTypes.string.isRequired,

      mobilePhone: PropTypes.string,

      email: PropTypes.string,
    }),
  }).isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(NewPrivateService);
